import { createContext } from 'react'

export type PlaybookViewContextType = {
  isShown: boolean
  toggle: () => void
}

export const PlaybookViewContext = createContext<
  PlaybookViewContextType | undefined
>(undefined)
